import * as _ from "lodash";
import { DocumentIsogd } from "isogd-document-rest";

class DocumentViewController {
    private document: DocumentIsogd;
    private documentRequisitesShow: boolean = true;
    private registrationShow: boolean = true;
    private territoryShow: boolean = true;
    private objectShow: boolean = true;
    private specificShow: boolean = true;
    private requestShow: boolean = true;
    private approveDocumentShow: boolean = true;
    private linkDocumentShow: boolean = true;
    private organizationsShow: boolean = true;
    private tepShow: boolean = true;
    private operatorShow: boolean = true;
}

export const DocumentViewComponent: angular.IComponentOptions = {
    controller: DocumentViewController,
    template: require('./documentView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/documentView.ts